"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  IllustratedMessage: true
};
exports.default = exports.IllustratedMessage = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Illustration = require("../Illustration/_Illustration");
var _IllustratedMessage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./IllustratedMessage.css") : void 0);
var _IllustratedMessage2 = require("./IllustratedMessage.types");
Object.keys(_IllustratedMessage2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _IllustratedMessage2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _IllustratedMessage2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-illustrated-message';
/** An **IllustratedMessage** is a recommended combination of a solution-oriented message,
 * engaging illustration, and conversational tone to better communicate an empty state
 * than just a message alone.
 *
 * An **IllustratedMessage** turns a situation (even a negative situation) into a better experience
 * for your users, while ensuring consistency. Through their human-centered approach,
 * **IllustratedMessage**s help to create a deeper connection with users by making
 * them feel understood, valued, and respected.
 *
 * To request additional illustrations, contact \#ask-core-ui. */
const IllustratedMessage = exports.IllustratedMessage = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(IllustratedMessage, _props)) : _props;
  const {
      additionalContent,
      additionalContentProps,
      children,
      className,
      description,
      descriptionProps,
      captionProps,
      headline,
      headlineProps,
      size = 'md',
      sceneContainerClassName
    } = props,
    otherProps = __rest(props, ["additionalContent", "additionalContentProps", "children", "className", "description", "descriptionProps", "captionProps", "headline", "headlineProps", "size", "sceneContainerClassName"]);
  const classnames = _bind.default.bind(_IllustratedMessage.default);
  const isDot = size === 'xs';
  const isSpot = size === 'sm';
  const isDialog = size === 'md';
  const isScene = !size || size === 'lg';
  const passChildProps = (child, childProps) => {
    if (child.displayName === 'Illustration') {
      return {
        ariaHidden: true,
        title: undefined,
        className: classnames(`${CSS_BLOCK}__svg`, childProps.className, {
          [`${CSS_BLOCK}__svg--dot`]: isDot,
          [`${CSS_BLOCK}__svg--spot`]: isSpot,
          [`${CSS_BLOCK}__svg--dialog`]: isDialog,
          [`${CSS_BLOCK}__svg--scene`]: isScene
        })
      };
    }
    if (_Illustration.ILLUSTRATION_TYPES.includes(child.displayName)) {
      return {
        size
      };
    }
    return {};
  };
  const textContent = /*#__PURE__*/_react.default.createElement("div", Object.assign({}, captionProps, {
    className: classnames(`${CSS_BLOCK}__caption`, captionProps === null || captionProps === void 0 ? void 0 : captionProps.className, {
      [`${CSS_BLOCK}__caption--dot`]: isDot,
      [`${CSS_BLOCK}__caption--spot`]: isSpot,
      [`${CSS_BLOCK}__caption--dialog`]: isDialog,
      [`${CSS_BLOCK}__caption--scene`]: isScene
    })
  }), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, headlineProps, {
    className: classnames(`${CSS_BLOCK}__headline`, headlineProps === null || headlineProps === void 0 ? void 0 : headlineProps.className, {
      [`${CSS_BLOCK}__headline--dot`]: isDot,
      [`${CSS_BLOCK}__headline--spot`]: isSpot,
      [`${CSS_BLOCK}__headline--dialog`]: isDialog,
      [`${CSS_BLOCK}__headline--scene`]: isScene
    })
  }), headline), description && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, descriptionProps, {
    className: classnames(`${CSS_BLOCK}__description`, descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className)
  }), description)));
  const additionalContentNode = additionalContent && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, additionalContentProps, {
    className: classnames(`${CSS_BLOCK}__additional`, additionalContentProps === null || additionalContentProps === void 0 ? void 0 : additionalContentProps.className, {
      [`${CSS_BLOCK}__additional--dot`]: isDot,
      [`${CSS_BLOCK}__additional--spot`]: isSpot,
      [`${CSS_BLOCK}__additional--dialog`]: isDialog,
      [`${CSS_BLOCK}__additional--scene`]: isScene
    })
  }), additionalContent));
  const nonDotIllustratedMessage = /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    ref: ref,
    className: classnames(CSS_BLOCK, className, {
      [`${CSS_BLOCK}--${size}`]: size !== 'md',
      [`${CSS_BLOCK}--spot`]: isSpot,
      [`${CSS_BLOCK}--dialog`]: isDialog,
      [`${CSS_BLOCK}--scene`]: isScene
    })
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children), textContent, additionalContentNode);
  const wrappedIllustratedMessage = isScene && size === 'lg' ? (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__large-scene-ctr`, sceneContainerClassName)
  }, nonDotIllustratedMessage)) : nonDotIllustratedMessage;
  return isDot ? (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classnames(`${CSS_BLOCK}__dot-ctr`, className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__horizontal`, CSS_BLOCK, {
      [`${CSS_BLOCK}--${size}`]: size !== 'md'
    })
  }, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children), textContent), additionalContent && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__dot-additional-row`)
  }, children && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__dot-additional-blank`)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__dot-additional-ctr`)
  }, additionalContentNode))))) : wrappedIllustratedMessage;
});
IllustratedMessage.displayName = 'IllustratedMessage';
var _default = exports.default = IllustratedMessage;